import React from "react";
import { Link } from "react-router-dom";
import {
  TrendingUp, Headset, Megaphone, Users, GanttChart, Wallet,
  ShoppingBag, Bot, BarChart3, Wrench, ArrowUpRight,
} from "lucide-react";

const ICONS = { TrendingUp, Headset, Megaphone, Users, GanttChart, Wallet, ShoppingBag, Bot, BarChart3, Wrench };

export function PillarIcon({ name, className = "w-5 h-5", strokeWidth = 1.6 }) {
  const Icon = ICONS[name] || GanttChart;
  return <Icon className={className} strokeWidth={strokeWidth} />;
}

export function StatusPill({ status }) {
  if (status === "live")
    return (
      <span className="inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full bg-[#7EE787]/20 text-[#1f6e35] font-mono-tech text-[9px] tracking-[0.18em] uppercase">
        <span className="w-1.5 h-1.5 rounded-full bg-[#2da043]" /> Live
      </span>
    );
  if (status === "page")
    return (
      <span className="inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full bg-[#F5F4F0] text-[#1A1A1A] font-mono-tech text-[9px] tracking-[0.18em] uppercase">
        Explore
      </span>
    );
  return (
    <span className="inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full bg-[#FDFCFB] border border-[#E8E6E1] text-[#6B6A68] font-mono-tech text-[9px] tracking-[0.18em] uppercase">
      Soon
    </span>
  );
}

export function productHref(p) {
  if (p.status === "live" && p.route) return p.route;
  if (p.marketingSlug) return `/products/${p.marketingSlug}`;
  return null;
}

export function ProductCard({ product, dark = false }) {
  const href = productHref(product);
  const inner = (
    <>
      <div className="flex items-start justify-between gap-3 mb-3">
        <h4
          className={`font-serif-display text-[17px] md:text-lg leading-tight tracking-tight ${
            dark ? "text-[#FDFCFB]" : "text-[#1A1A1A]"
          }`}
        >
          {product.name}
        </h4>
        <StatusPill status={product.status} />
      </div>
      <p
        className={`text-[13px] leading-relaxed ${
          dark ? "text-[#FDFCFB]/65" : "text-[#6B6A68]"
        }`}
      >
        {product.desc}
      </p>
      {href && (
        <div
          className={`mt-4 inline-flex items-center gap-1.5 text-[10px] tracking-[0.18em] uppercase font-mono-tech ${
            dark ? "text-[#FDFCFB]/80" : "text-[#1A1A1A]/70"
          }`}
        >
          {product.status === "live" ? "Open app" : "Explore"}
          <ArrowUpRight className="w-3 h-3" />
        </div>
      )}
    </>
  );
  const className = `block p-5 rounded-xl transition-all ${
    dark
      ? "bg-[#FDFCFB]/[0.04] border border-[#FDFCFB]/10 hover:bg-[#FDFCFB]/[0.08]"
      : "bg-[#FDFCFB] border border-[#E8E6E1] hover:border-[#1A1A1A]/30 hover:-translate-y-0.5 hover:shadow-[0_18px_30px_-20px_rgba(0,0,0,0.18)]"
  } ${href ? "cursor-pointer" : "cursor-default"}`;

  return href ? (
    <Link to={href} className={className}>
      {inner}
    </Link>
  ) : (
    <div className={className}>{inner}</div>
  );
}
